export const DynamicLoader = () => {
 return <div className="up-fullloader up-smallloader">
 <div className="lds-dual-ring"></div>
</div>
}